import React, { useEffect, useRef } from 'react';
import { Grid } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import DyanamicDropdown from 'components/Elements/DynamicDropdown';
import { useFilters } from '../FilterContext';
import { useModels } from './hooks/useModels';
import { useFilterInitialization } from './hooks/useFilterInitialization';
import { SHOW_ALL_OPTION } from '../constants';

export const ModelFilter = () => {
  const { filterValues, updateFilter, isRequired, isShowAll } = useFilters();
  const departmentValue = filterValues.department?.value;
  const models = useModels(departmentValue, isShowAll('model'));
  const prevDepartmentRef = useRef();

  // Reset model when department changes
  useEffect(() => {
    const departmentKey = JSON.stringify(departmentValue);
    if (prevDepartmentRef.current !== undefined && prevDepartmentRef.current !== departmentKey) {
      // Department changed - clear model selection
      const defaultValue = isShowAll('model') ? SHOW_ALL_OPTION : {};
      updateFilter('model', defaultValue, {
        modelId: defaultValue.id,
        modelVersionId: defaultValue.activeModelVersionID,
        modelTemplateType: defaultValue.modelTemplateType
      });
    }
    prevDepartmentRef.current = departmentKey;
  }, [JSON.stringify(departmentValue), updateFilter, isShowAll]);

  // All the complex initialization logic is now handled by the hook
  useFilterInitialization('model', models, {
    dependencies: [JSON.stringify(departmentValue)],
    resetOnDependencyChange: true,
    waitForData: true,
    getDefaultValue: () => isShowAll('model') ? SHOW_ALL_OPTION : {},
    getParams: (model) => ({
      modelId: model.id,
      modelVersionId: model.activeModelVersionID,
      modelTemplateType: model.modelTemplateType
    })
  });

  return (
    <Grid item lg={3} md={6} xs={12}>
      <DyanamicDropdown
        dataSource={models}
        columns={[{ name: 'name', id: 1 }]}
        showHeader={false}
        width="100%"
        placeholder="Select Model"
        onChange={item => updateFilter('model', item, { 
          modelId: item.id,
          modelVersionId: item.activeModelVersionID,
          modelTemplateType: item.modelTemplateType
        })}
        selectdValueToshow="name"
        selectedValue={filterValues.model?.value}
        label="Filter by Model"
        icon={<FilterListIcon style={{ color: 'rgb(48,122,215)' }} />}
        required={isRequired('model')}
        showBorderColor
      />
    </Grid>
  );
}; 


